export const recaptchaApi = {
  configurationRecaptcha: 'config/r/CO/v1/property/RECAPTCHA.CONFIG',
  configurationGcloud: 'v1/projects/web-farmatodo/assessments'
};